import Reflux from 'reflux';
import ModalActions from '../actions/ModalActions';

export default class ModalStore extends Reflux.Store {
    constructor () {
        super();
        this.state = {
            isModalLoginShowing: false,
            isSearchModalShowing: false,
            searchAvailable: false
        };
        this.listenables = ModalActions;
    }

    onChangeModalLoginStatus (showModal) {
        this.setState({isModalLoginShowing: showModal});
    }
    onChangeSearchModalStatus (showModal) {
        this.setState({isSearchModalShowing: showModal});
        setTimeout(() => {
            this.setState({searchAvailable: showModal});
        }, 10);
    }
}



// WEBPACK FOOTER //
// ./src/stores/ModalStore.js